module.exports = __webpack_public_path__ + "static/media/bell.877d82b3.svg";